import api from '../../common/dependencies/utils/Api';
import {
    GET_A_MENTOR_DATA,GET_SIGNAL_MENTOR_DATA,
    VIEW_STARTUP_APPLICATION_DATA
} from "../../common/constants/ApplicationUrl";

export const HomeServices = {
    currentInervention(params) {
        
        return api.GET(`${GET_A_MENTOR_DATA}`)
            .then((response) => {
                const { data: { responseCode, data } = {} } = response;
                if (responseCode === 200) {
                    return data;
                } else {
                    return Promise.reject(response.data);
                }
            }).catch(e => {
                return Promise.reject(e);
            });
    },

}

export const getMentorData1 = {
    mentorListData(params) {
        // if(localStorage.getItem("SavedLoggedInData") && JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role){

        return api.POST(`${GET_SIGNAL_MENTOR_DATA}`,params)
        .then((response) => {
            const { data: { responseCode, data,success } = {} } = response;
            if (success) {
                return response.data;
            } else {
                return null;
            }
        }).catch(e => {
            return null
            // return Promise.reject(e);
        });
    }
    // }
}

export const getStartupData1 = {
    startupData(params) {
        return api.POST(`${VIEW_STARTUP_APPLICATION_DATA}`,params)
        .then((response) => {
            const { data: { responseCode, data,success } = {} } = response;
            if (success) {
                return response.data;
            } else {
                return Promise.reject(response.data);
            }
        }).catch(e => {
            return Promise.reject(e);
        });
    }
}